import { IDepositsToRedeem, IPayment, IPaymentCurrencyBreakDown } from '../../interface';

export class ReconciliationOverviewDto {
  merchantId: number;
  merchantName: string;
  isMultiCurrency: boolean;
  grossSales: number;
  discount: number;
  serviceCharge: number;
  gratuities: number;
  grossAfter: number;
  giftCardSales: number;
  depositsCollected: number;
  totalGrossRevenue: number;
  otherPayments: IPayment[];
  depositsToRedeem: IDepositsToRedeem;
  integrations: IPayment[];
  kiosk:  number;
  sweetFace?:  number;
  totalToReconcile: IPaymentCurrencyBreakDown[];
  totalReconciled: IPaymentCurrencyBreakDown[];
  depositsUnRedeemed: IPaymentCurrencyBreakDown[];
  variance: IPaymentCurrencyBreakDown[];
  totalPos: number;
  totalKiosk: number;
  totalReconciliationSweetFace?: number;
  totalIntegrations: number;
}